import React, { memo } from 'react'
import s from '../../css/status/statusItem.module.css'
import { getLatencyLevel, LATENCY_LABELS } from '../../helpers/statusHelper'

const StatusContainer = memo(({ endpoint, status, latencyMs }) => {
	const isOk = status === 200
	const level = getLatencyLevel(latencyMs)

	return (
		<li className={s.tag}>
			<div className={s.endpoint}>{endpoint}</div>
			<div className={s.latencyCell}>
				{isOk ? (
					<span
						className={`${s.latencyDot} ${s[level]}`}
						title={LATENCY_LABELS[level]}
						aria-label={LATENCY_LABELS[level]}
					/>
				) : (
					'—'
				)}
			</div>
			<div className={s.statusCell}>
				<span className={`${s.pill} ${isOk ? s.ok : s.err}`}>
					<span className={s.dot} />
					{isOk ? 'ОК' : 'ОШИБКА'}
				</span>
			</div>
		</li>
	)
})

export default StatusContainer
